import * as z from "zod/v4";

export const setCustomDomainMailFromDomain = {
  name: "setCustomDomainMailFromDomain" as const,
  input: z.object({ mailFromDomain: z.string() }),
  output: z.null(),
};
